<script>
    export default {
        props: {
            show: Boolean,
            text: String,
            backdrop: Boolean
        },
        data() {
            return {
                parentElement: null
            };
        },
        mounted() {
            if (this.$el && this.$el.parentElement) this.parentElement = this.$el.parentElement;
        },
        watch: {
            show(val) {
                if (this.parentElement != null) {
                    if (val) {
                        this.parentElement.style.position = 'relative';
                        this.parentElement.style.pointerEvents = 'none';
                    } else {
                        this.parentElement.style.position = '';
                        this.parentElement.style.pointerEvents = '';
                    }
                }
            }
        }
    };
</script>
<template>
    <span v-if="show" class="app-spinner" :class="{ backdrop: backdrop !== false }">
        <span class="app-spinner-container">
            <span class="spinner-border text-primary" role="status"></span>
            <span class="spinner-text">{{ !!text ? text : 'Loading...' }}</span>
        </span>
    </span>
</template>

<style lang="scss">
    .app-spinner {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        display: flex;
        align-content: flex-start;
        justify-content: center;
        z-index: 99;

        &.backdrop {
            background: rgba(255, 255, 255, 0.8);
            pointer-events: none;
        }

        .app-spinner-container {
            margin: 2% auto 0 auto;
            height: 45px;
            line-height: 45px;
            padding: 0 1rem;
            border: 1px solid #ddd;
            background: white;
            border-radius: 5px;
        }

        @media (max-width: 767px) {
            .app-spinner-container {
                height: 60px;
                line-height: 20px;
                padding: 0.75rem 1rem 0;
                text-align: center;

                .spinner-text {
                    display: block;
                    margin-top: 0.25rem;
                }
            }
        }
    }
</style>
